.bar {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-16);
  min-height: 48px;
}

.home {
  border-radius: var(--zumpo-radius-8);
  color: inherit;
  text-decoration: none;
}

.home:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.divider {
  flex: none;
  width: 1px;
  height: 28px;
  background: var(--zumpo-line);
}

.identity {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--zumpo-space-12);
  min-width: 0;
}

/* Given less than its name, as beside the buttons of a 320 px phone, the
   heading ends in an ellipsis rather than reach under them. */
.game {
  overflow: hidden;
  max-width: 100%;
  font: var(--zumpo-text-heading);
  letter-spacing: var(--zumpo-text-heading-tracking);
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The name scaled to fit a phone's bar takes the heading's whole line and
   lies at its top, so its smaller line never makes the bar taller
   (useFittedName in room-bar.tsx). */
.name {
  vertical-align: top;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--zumpo-space-12);
}

.phone {
  --zumpo-avatar-size: 32px;

  gap: var(--zumpo-space-8);
}

/* Option B: the three icon buttons 38 x 48, so the game's name keeps 172 px
   at 390 px. */
.phone .action {
  padding-inline: var(--zumpo-space-8);
}

.phone .identity {
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 0;
}

/* The room and its phase under the game, in one line however long. The
   phase, a few words saying where the game is, is always whole; the lead
   before it, such as Watching, goes as a whole where both do not fit, and the
   room's name ends in an ellipsis, or goes too where not even a few letters
   fit. The pieces wrap in that order of need, the phase first, onto lines
   the box cuts off, and are laid back in reading order from the right, so
   what goes takes its separator with it and nothing reaches under the
   buttons. Pre, so the separators' spaces are kept at the ends of boxes. */
.context {
  display: flex;
  overflow: hidden;
  flex-flow: row-reverse wrap;
  justify-content: flex-end;
  height: 1lh;
  min-width: 0;
  color: var(--zumpo-muted);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  white-space: pre;
}

.room {
  display: flex;
  flex: 1 1 var(--zumpo-space-64);
  order: 3;
  min-width: 0;
  max-width: max-content;
}

.roomName {
  overflow: hidden;
  min-width: 0;
  text-overflow: ellipsis;
}

.lead {
  flex: none;
  order: 2;
}

/* Cut only where it alone is wider than the line, as no phase is yet. */
.phase {
  overflow: hidden;
  flex: 0 1 auto;
  order: 1;
  min-width: 0;
  text-overflow: ellipsis;
}
